import { render } from "./app-form-industries.vue?vue&type=template&id=59efaf99"
import script from "./app-form-industries.vue?vue&type=script&lang=js"
export * from "./app-form-industries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-industries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59efaf99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59efaf99', __exports__)) {
    console.log('reload')
    api.reload('59efaf99', __exports__)
  }
  
  module.hot.accept("./app-form-industries.vue?vue&type=template&id=59efaf99", () => {
    console.log('re-render')
    api.rerender('59efaf99', render)
  })

}


export default __exports__